export default __webpack_public_path__ + "static/preview-e75a45a05adf904b546833d9bd29d19e.png";